$(document).ready(function() {
    let $modalformId = $('.gc-form-modal').attr('id');
    if ($('.contact-btn').length) {
        $('.contact-btn').attr('data-bs-target', '#'+$modalformId);
    }
});